export default __webpack_public_path__ + "static/meg-c959d871e513fad2a400f320917e2129.png";